<template>
  <div class="card">
    <div class="card-body overflow-auto chat" ref="chatContainer">
      <div ref="chatContent">
        <div v-for="message in messages" :key="message.id">
          <div>
            <b>{{ message.user.first_name }} {{ message.user.last_name }}</b>
            <span :id="'message-'+message.id">
                            {{ message.created_at | relative }}
                        </span>
            <b-tooltip :target="'message-'+message.id" triggers="hover">
              {{ message.created_at | exact }}
            </b-tooltip>
          </div>
          {{ message.content }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const axios = require('axios');
  const moment = require('moment');

  export default {
    name: "Chat",
    data() {
      return {
        messages: [],
      }
    },
    filters: {
      relative: function (date) {
        moment.locale('it');
        return moment(date).fromNow();
      },
      exact: function (date) {
        moment.locale('it');
        return moment(date).format("LLL");
      }
    },
    props: {
      eventId: String,
      baseUrl: String,
    },
    mounted() {
      axios.get(`${this.baseUrl}/old_messages`).then(function (response) {
        this.messages = response.data;
        Echo.channel(`event.${this.eventId}`)
          .listen('ChatMessageReceived', (e) => {
            this.messages.push(e.chatMessage);
          });
      }.bind(this));
    },
    updated() {
      this.$refs.chatContainer.scrollTop = this.$refs.chatContent.clientHeight;
    }
  }
</script>

<style scoped>
  .chat {
    max-height: 350px;
  }
</style>
